import React, { useEffect } from "react"
import { Form, Input, Button } from "antd"
import _ from 'lodash'

const DataForm = (props) => {
  const [form] = Form.useForm()
  useEffect(() => {
    if(!_.isEmpty(props.selectedSubCategory) && props.showUpdateModal){
      form.setFieldsValue(props.selectedSubCategory)
    }
  }, [])
  return (
    <Form
      form={form}
      autoComplete="off"
      layout="vertical"
      onFinish={props.onSubmit}
    >
      <Form.Item
        label="Name"
        name="subcategory_name"
        rules={[{ required: true, message: "Please enter sub-category name" }]}
      >
        <Input size="large" placeholder="Sub-Category Name" />
      </Form.Item>
      <Button type="primary" htmlType="submit" className="ml-auto">
        Save
      </Button>
    </Form>
  )
}

export default DataForm
